(function () {
  "use strict";

  class ProductCardModelComponent extends HTMLElement {
    constructor() {
      super();
      this._isConnected = false;
      this._needsRender = false;
      this._renderRAF = null;
      this._lastHTML = null;
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      if (this._isConnected) {
          this._scheduleRender();
      } else {
        this._needsRender = true;
      }
    }

    connectedCallback() {
      this._isConnected = true;
      if (this._product && this._needsRender) {
        this._scheduleRender();
        this._needsRender = false;
      } else if (this._product && this._lastHTML == null) {
        this._scheduleRender();
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      if (this._renderRAF) {
        cancelAnimationFrame(this._renderRAF);
        this._renderRAF = null;
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === "product" && newVal && newVal !== oldVal) {
        try {
          const parsed = JSON.parse(newVal);
          this.product = parsed;
        } catch (e) {
          // ignore invalid JSON
        }
      }
    }

    _scheduleRender() {
      if (this._renderRAF) cancelAnimationFrame(this._renderRAF);
      this._renderRAF = requestAnimationFrame(() => {
        this._renderRAF = null;
        this._doRender();
      });
    }

    _doRender() {
      if (!this._product) {
        this.innerHTML = "";
        this._lastHTML = null;
        return;
      }

      const safeText = (val) => (val == null ? "" : String(val));

      // Get stibo product ID from metafields array
      const metafields = Array.isArray(this._product?.metafields)
        ? this._product.metafields
        : [];

      const stiboProductId = safeText(metafields[0]?.value || "").split('_')[0];

      // Build the product ID section
      const html = `
              ${
                stiboProductId
                  ? `<p><span class="uppercase">Model: </span><span>${safeText(
                      stiboProductId
                    )}</span></p>`
                  : ""
              }
      `;
      if (html !== this._lastHTML) {
        this.innerHTML = html;
        this._lastHTML = html;
      }
    }
  }

  customElements.define("rcc-product-card-model", ProductCardModelComponent);
})();
